import { useState } from 'react';

function PollWall({ polls, onAddPoll, onAddOption, onVote, onDeletePoll, onDeleteOption }) {
  const [newQuestion, setNewQuestion] = useState('');
  const [optionDrafts, setOptionDrafts] = useState({});
  const [rollResult, setRollResult] = useState({});

  const handleAddPoll = () => {
    if (!newQuestion.trim()) return;
    onAddPoll?.(newQuestion.trim());
    setNewQuestion('');
  };

  const handleAddOption = (pollId) => {
    const text = optionDrafts[pollId] || '';
    if (!text.trim()) return;
    onAddOption?.(pollId, text.trim());
    setOptionDrafts((prev) => ({ ...prev, [pollId]: '' }));
  };

  const handleRoll = (poll) => {
    const pool = poll.options;
    if (!pool.length) return;
    const pick = pool[Math.floor(Math.random() * pool.length)];
    setRollResult((prev) => ({ ...prev, [poll.id]: pick.id }));
  };

  return (
    <section className="panel">
      <div className="panel-head">
        <div>
          <p className="eyebrow">Interactive Q&A / Voting Wall</p>
          <h2>Ask, Vote, Draw Lots</h2>
          <p className="sub small">Create topics, add options, and let friends vote together</p>
        </div>
      </div>

      <div className="card compact">
        <div className="card-head">
          <span className="card-icon">🧊</span>
          <div>
          <p className="eyebrow">New Topic</p>
          <h3>Write your question</h3>
          </div>
        </div>
        <div className="form-row">
          <input
            className="input"
            placeholder="Example: What to eat / play / watch tonight?"
            value={newQuestion}
            onChange={(e) => setNewQuestion(e.target.value)}
          />
          <button className="secondary" onClick={handleAddPoll}>
            Create
          </button>
        </div>
      </div>

      <div className="poll-grid">
        {polls.map((poll) => {
          const totalVotes = poll.options.reduce((sum, opt) => sum + (opt.votes || 0), 0);
          return (
            <div key={poll.id} className="card poll-card">
              <div className="card-head">
                <span className="card-icon">💬</span>
                <div>
                  <p className="eyebrow">Topic</p>
                  <h3>{poll.question}</h3>
                </div>
                <button className="pill danger" onClick={() => onDeletePoll?.(poll.id)}>
                  Delete Topic
                </button>
              </div>

              <div className="option-list">
                {poll.options.map((opt) => {
                  const percent = totalVotes ? Math.round(((opt.votes || 0) / totalVotes) * 100) : 0;
                  const isPicked = rollResult[poll.id] === opt.id;
                  return (
                    <div
                      key={opt.id}
                      className={`option ${isPicked ? 'picked' : ''}`}
                      role="button"
                      tabIndex={0}
                      onClick={() => onVote?.(poll.id, opt.id)}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                          e.preventDefault();
                          onVote?.(poll.id, opt.id);
                        }
                      }}
                    >
                      <div className="option-top">
                        <span>{opt.text}</span>
                        <span className="badge">{opt.votes || 0} votes</span>
                      </div>
                      <div className="option-bar">
                        <div className="option-fill" style={{ width: `${percent}%` }} />
                      </div>
                      <div className="option-actions">
                        <div className="option-sub">{percent}%</div>
                        <button
                          type="button"
                          className="pill danger option-delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            onDeleteOption?.(poll.id, opt.id);
                          }}
                        >
                          Delete
                        </button>
                      </div>
                    </div>
                  );
                })}
                {!poll.options.length && <div className="item-sub">No options yet—add one to start</div>}
              </div>

              <div className="form-row">
                <input
                  className="input"
                  placeholder="Add an option"
                  value={optionDrafts[poll.id] || ''}
                  onChange={(e) => setOptionDrafts((prev) => ({ ...prev, [poll.id]: e.target.value }))}
                />
                <button className="secondary" onClick={() => handleAddOption(poll.id)}>
                  Add option
                </button>
                <button className="secondary ghost" onClick={() => handleRoll(poll)}>
                  Pick one at random
                </button>
              </div>
            </div>
          );
        })}
        {!polls.length && <div className="item-sub">No topics yet—create one!</div>}
      </div>
    </section>
  );
}

export default PollWall;

